<!-- -->

<div><button class="close" mat-button (click)="onNoClick()">X</button></div>

<div>
  <img src="{{imageViewUrl}}" class="imgSize" />
</div>


